<template>
  <div class="layout">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-inner">
        <router-link to="/home" class="brand">
          <img v-if="logoSrc" :src="logoSrc" alt="果速达" class="logo-img" @error="handleLogoError">
        </router-link>

        <!-- 桌面端导航 -->
        <nav class="nav-desktop">
          <!-- 有子菜单的显示下拉 -->
          <el-dropdown v-for="menu in menusWithChildren" :key="menu.id" trigger="click" class="nav-item" :class="{ 'nav-item-active': isMenuActive(menu) }">
            <span class="nav-link" :class="{ 'nav-link-active': isMenuActive(menu) }" @click="handleMenuClick(menu)">
              {{ menu.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="child in menu.children" :key="child.id" :class="{ 'is-active': isMenuActive(child) }" @click.native="handleMenuClick(child)">
                {{ child.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 无子菜单的显示普通链接 -->
          <router-link v-for="menu in menusWithoutChildren" :key="menu.id" :to="getMenuPath(menu)" class="nav-link" active-class="nav-link-active" @click.native="handleMenuClick(menu)">
            {{ menu.name }}
          </router-link>
        </nav>

        <!-- 移动端汉堡菜单 <a-icon type="menu" />-->
        <el-button class="nav-toggle" type="text" icon="el-icon-s-fold" @click="drawerVisible = true" />
      </div>
    </header>

    <!-- 移动端抽屉：从右侧滑出 -->
    <el-drawer :visible.sync="drawerVisible" direction="rtl" size="78%" custom-class="nav-drawer">
      <div class="drawer-inner">
        <!-- 右上角绿色关闭按钮 -->
        <!-- <button type="button" class="drawer-close" aria-label="关闭菜单" @click="drawerVisible = false">
          <i class="el-icon-close"></i>
        </button> -->

        <div class="nav-mobile">
          <router-link to="/home" class="nav-mobile-item" active-class="nav-mobile-item-active" @click.native="drawerVisible = false">
            <span class="nav-mobile-text">首页</span>
          </router-link>

          <!-- 有子菜单的一级项：可展开/折叠 -->
          <div v-for="menu in menusWithChildren" :key="String(menu.id)" class="nav-mobile-group">
            <div class="nav-mobile-item" :class="{ 'nav-mobile-item-active': isMenuActive(menu), 'nav-mobile-item-expanded': String(expandedMenuId) === String(menu.id) }" @click="toggleExpand(menu.id)">
              <span v-if="isMenuActive(menu)" class="nav-mobile-dot"></span>
              <span class="nav-mobile-text">{{ menu.name }}</span>
              <i class="el-icon-arrow-down nav-mobile-arrow" :class="{ 'is-expanded': String(expandedMenuId) === String(menu.id) }"></i>
            </div>
            <div v-if="String(expandedMenuId) === String(menu.id)" class="nav-mobile-children-wrap">
                <router-link v-for="child in menu.children" :key="child.id" :to="getMenuPath(child)" class="nav-mobile-item nav-mobile-child" :class="{ 'nav-mobile-item-active': isMenuActive(child) }" @click.native="drawerVisible = false">
                  <span class="nav-mobile-text">{{ child.name }}</span>
                </router-link>
              </div>
          </div>

          <!-- 无子菜单的一级项 -->
          <router-link v-for="menu in menusWithoutChildren" :key="menu.id" :to="getMenuPath(menu)" class="nav-mobile-item" active-class="nav-mobile-item-active" @click.native="drawerVisible = false">
            <span v-if="isMenuActive(menu)" class="nav-mobile-dot"></span>
            <span class="nav-mobile-text">{{ menu.name }}</span>
          </router-link>
        </div>
      </div>
    </el-drawer>

    <main class="content">
      <router-view />
    </main>

    <!-- 页脚：PC 端始终显示；移动端首页时在轮播最后一项展示，此处隐藏 -->
    <footer v-if="showLayoutFooter" class="footer">
      <div class="footer-inner">
        <div class="footer-left">
          <div v-if="footerRemarkHtml" class="footer-remark" v-html="footerRemarkHtml"></div>
          <p v-if="authInfo" class="copyright">{{ authInfo }}</p>
        </div>
        <div class="footer-right">
          <template v-if="qrCodes.length">
            <div v-for="(qr, index) in qrCodes" :key="index" class="qr-item">
              <div class="qr-box"><img :src="qr" alt="二维码" @error="($event.target.style.display='none')"></div>
            </div>
          </template>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LayoutPage',
  data () {
    return {
      drawerVisible: false,
      expandedMenuId: null, // 当前展开的一级菜单 id
      isMobile: false,
      logoError: false
    }
  },
  computed: {
    isHomePage () {
      return this.$route.name === 'Home' || this.$route.path === '/home' || this.$route.path.endsWith('/home')
    },
    // PC 端始终显示 footer；移动端仅非首页时显示（首页时 footer 在轮播最后一项）
    showLayoutFooter () {
      return !this.isHomePage
    },
    // 页脚与 logo 数据与首页 hero-footer-slide 共用 Vuex globalConfig
    logoSrc () {
      if (this.logoError) return ''
      return this.$store.getters.globalConfigLogo
    },
    footerRemarkHtml () {
      return this.$store.getters.globalConfigRemarkInfo
    },
    authInfo () {
      return this.$store.getters.globalConfigAuthInfo
    },
    qrCodes () {
      return this.$store.getters.globalConfigQrCodes
    },
    menuList () {
      // 从 Vuex 获取菜单列表
      return this.$store.getters.menuList
    },
    menusWithChildren () {
      return this.menuList.filter(menu => menu.children && menu.children.length > 0)
    },
    menusWithoutChildren () {
      return this.menuList.filter(menu => !menu.children || menu.children.length === 0)
    }
  },
  mounted () {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  watch: {
    drawerVisible (visible) {
      if (visible) {
        // 打开时展开当前路由所属的一级菜单
        const cur = this.menusWithChildren.find(m => this.isMenuActive(m))
        this.expandedMenuId = cur ? String(cur.id) : null
      }
    }
  },
  methods: {
    toggleExpand (menuId) {
      const id = String(menuId)
      this.expandedMenuId = this.expandedMenuId === id ? null : id
    },
    checkMobile () {
      this.isMobile = window.innerWidth <= 768
    },
    handleLogoError () {
      this.logoError = true
    },
    // 获取菜单路径
    getMenuPath (menu) {
      // 如果菜单有 code，根据 code 生成路径
      if (menu.code) {
        return `/menu/${menu.code.toLowerCase()}`
      }
      // 默认使用菜单ID
      return `/menu/${menu.id}`
    },
    // 处理菜单点击
    handleMenuClick (menu) {
      if (menu.code === 'W0002' || menu.code === 'W0003') {
        return
      }
      this.drawerVisible = false
      // 根据菜单 code 进行路由跳转
      if (menu.code) {
        this.$router.push({
          path: `/menu/${menu.code.toLowerCase()}`
        }).catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转失败:', err)
          }
        })
      } else if (menu.id) {
        this.$router.push({
          path: `/menu/${menu.id}`
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('路由跳转失败:', err)
          }
        })
      }
    },
    // 判断菜单是否激活
    isMenuActive (menu) {
      const currentPath = this.$route.path
      // 检查当前菜单是否激活
      let isActive = false
      if (menu.code) {
        const menuPath = `/menu/${menu.code.toLowerCase()}`
        isActive = currentPath === menuPath
      } else if (menu.id) {
        const menuPath = `/menu/${menu.id}`
        isActive = currentPath === menuPath
      }

      // 如果有子菜单，检查子菜单是否激活
      if (!isActive && menu.children && menu.children.length > 0) {
        isActive = menu.children.some(child => this.isMenuActive(child))
      }

      return isActive
    }
  }
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #333;
}

.logo-img {
  height: 36px;
}
.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #52c41a, #389e0d);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
}
.brand-name {
  font-size: 18px;
  font-weight: 600;
}
.brand-divider {
  color: #ccc;
  margin: 0 4px;
}
.brand-slogan {
  font-size: 14px;
  color: #666;
}

.nav-desktop {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nav-item {
  margin: 0;
}
.nav-link {
  color: #52c41a;
  font-size: 17px;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s;
}
.nav-link:hover {
  color: #52c41a;
}
.nav-link-active {
  color: #ff8c00;
  font-weight: 600;
}
.nav-item-active .nav-link {
  color: #ff8c00;
  font-weight: 600;
}
/* 下拉菜单子项激活状态 */
.nav-item ::v-deep .el-dropdown-menu__item.is-active {
  color: #ff8c00;
  background-color: #fff7e6;
}
.nav-toggle {
  display: none !important;
  font-size: 24px;
  color: #52c41a;
}

.content {
  flex: 1;
}

.footer {
  background: #1a472a;
  color: #fff;
  padding: 40px 20px 24px;
}
.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 32px;
}
.footer-left p,
.footer-remark p {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.6;
}
.footer-remark ::v-deep a {
  color: #fff;
  text-decoration: none;
}
.footer-remark ::v-deep a:hover {
  text-decoration: underline;
}
.footer-left a {
  color: #fff;
  text-decoration: none;
}
.footer-left a:hover {
  text-decoration: underline;
}
.copyright {
  margin-top: 12px;
  font-size: 12px;
  opacity: 0.9;
}

.footer-right {
  display: flex;
  gap: 24px;
}
.qr-item {
  text-align: center;
  font-size: 12px;
}
.qr-box {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.qr-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nav-mobile {
  padding: 0;
  display: flex;
  flex-direction: column;
}
.drawer-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
/* 右上角绿色关闭按钮 */
.drawer-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  width: 40px;
  height: 40px;
  border: none;
  background: #52c41a;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  padding: 0;
  transition: background 0.2s;
}
.drawer-close:hover {
  background: #389e0d;
}
/* 菜单项：每项下方细分隔线 */
.nav-mobile-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
}
.nav-mobile-item:hover {
  color: #52c41a;
}
/* 选中态：绿色文字 + 左侧粉点 */
.nav-mobile-item-active .nav-mobile-text {
  color: #52c41a;
  font-weight: 600;
}
.nav-mobile-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ff85a2;
  margin-right: 10px;
  flex-shrink: 0;
}
.nav-mobile-text {
  flex: 1;
}
/* 展开/折叠箭头 */
.nav-mobile-arrow {
  font-size: 12px;
  color: #999;
  transition: transform 0.2s;
  margin-left: 8px;
}
.nav-mobile-arrow.is-expanded {
  transform: rotate(180deg);
}
/* 二级菜单缩进 */
.nav-mobile-child {
  padding-left: 40px;
  font-size: 15px;
  color: #666;
}
.nav-mobile-child.nav-mobile-item-active .nav-mobile-text {
  color: #52c41a;
}
.nav-mobile-group {
  display: flex;
  flex-direction: column;
}
.nav-mobile-children-enter-active,
.nav-mobile-children-leave-active {
  transition: opacity 0.2s;
}
.nav-mobile-children-enter,
.nav-mobile-children-leave-to {
  opacity: 0;
}
/* 抽屉容器：左侧滑出、白色背景 */
::v-deep .nav-drawer {
  background: #fff;
}
::v-deep .nav-drawer .el-drawer__body {
  padding: 0;
  overflow: auto;
  height: 100%;
}
.drawer-inner .nav-mobile {
  flex: 1;
  /* padding-top: 56px; */
}

/* 移动端 */
@media (max-width: 768px) {
  .nav-desktop {
    display: none;
  }
  .nav-toggle {
    display: inline-block !important;
  }
  .brand-slogan {
    display: none;
  }
  .brand-divider {
    display: none;
  }
  .header-inner {
    height: 56px;
    padding: 0 6px;
  }

  .footer-inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .footer-left {
    order: 2;
  }
  .footer-right {
    order: 1;
    flex-wrap: wrap;
    justify-content: center;
  }
  .qr-box {
    width: 64px;
    height: 64px;
  }
}
</style>
